<template lang="pug">
  .user-profile
    .user-profile__title
      h1.title Профиль
    .user-profile__text Здесь вы можете изменить данные своего профиля, следить за статусом заявки, а также загрузить все необходимые для подачи заявки документы.
    .user-profile__main
      form.profile-page-form
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Общая информация
          .profile-section__body
            form-general-info(
            :last-name="userProfileData.last_name"
            :first-name="userProfileData.first_name"
            :fathers-name="userProfileData.fathers_name"
            :gender="userProfileData.gender"
            :date-of-birth="userProfileData.date_of_birth"
            :place-of-birth="userProfileData.place_of_birth"
            :is-accompanying="userProfileData.is_accompanying"
            :fields-errors="fieldsErrors"
            :reset-error="resetError"
            @onChangeValue="changeValue"
            )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title {{userProfileData.is_accompanying ? "Место работы" : "Учебное заведение"}}
          .profile-section__body
            form-educational-institution(
            :areasList="areasList"
            :area="userProfileData.area"
            :school-address="userProfileData.school_address"
            :school-name="userProfileData.school_name"
            :fields-errors="fieldsErrors"
            :is-accompanying="userProfileData.is_accompanying"
            :reset-error="resetError"
            @onChangeValue="changeValue"
            )
        section.profile-page-form__section.profile-section
          .profile-section__title
            h2.profile-section-title Контакты
          .profile-section__body
            form-contacts(
            :email="userProfileData.email"
            :phone="userProfileData.phone"
            :parent-name="userProfileData.parent_name"
            :parents-phone="userProfileData.parents_phone"
            :is-accompanying="userProfileData.is_accompanying"
            :fields-errors="fieldsErrors"
            :reset-error="resetError"
            @onChangeValue="changeValue"
            )
        section.profile-page-form__section.profile-section(
        id="portfolio"
        v-if="!userProfileData.is_accompanying"
        )
          .profile-section__title
            h2.profile-section-title Портфолио ребенка за последний год
          .profile-section__body
            form-portfolio(
              :user-awards-data="userAwardsData"
              :award-types-data="awardTypesData"
              @onChangePortfolioValue="changePortfolioValue"
              @onOpenModal="openModal"
              @onDeleteAward="onDeleteAward"
            )
        section.profile-page-form__section.profile-section
          .profile-section__body
            .form
              .form__elem.form__elem_align-right.form__elem_full
                .form-elem
                  .form-elem__main
                    button.button.button_paint-main.button_long(
                      :class="{ 'loaded-button': pending }"
                      @click.prevent="onSaveProfile()"
                    )
                      .button__text Сохранить
                  .form-elem__error(
                  v-if="currentErrorMessage.length > 0"
                  ) {{ currentErrorMessage }}
</template>

<script>
import { mapState, mapActions } from "vuex";
import FormGeneralInfo from "./components/form-general-info";
import FormEducationalInstitution from "./components/form-educational-institution";
import FormContacts from "./components/form-contacts";
import FormDocs from "./components/form-docs";
import FormPortfolio from "./components/form-portfolio";

export default {
  name: "user-profile",
  components: {
    FormPortfolio,
    FormDocs,
    FormContacts,
    FormEducationalInstitution,
    FormGeneralInfo,
  },
  data() {
    return {
      pending: false,
      userProfileData: {},
      userAwardsData: [],
      awardTypesData: [],
      awardCompetition: {},
      awardPlaces: [],
      fieldsErrors: {
        last_name: {
          value: false,
          message: "Введите вашу фамилию",
        },
        first_name: {
          value: false,
          message: "Введите ваше имя",
        },
        fathers_name: {
          value: false,
          message: "Введите ваше отчество",
        },
        date_of_birth: {
          value: false,
          message: "Укажите дату рождения",
        },
        place_of_birth: {
          value: false,
          message: "Укажите место рождения",
        },
        school_address: {
          value: false,
          message: "Укажите адрес учебного заведения",
        },
        school_name: {
          value: false,
          message: "Укажите учебное заведение",
        },
        work_address: {
          value: false,
          message: "Укажите рабочий адрес",
        },
        work_name: {
          value: false,
          message: "Укажите место работы",
        },
        empty_phone: {
          value: false,
          message: "Введите номер телефона",
        },
        empty_parents_phone: {
          value: false,
          message: "Введите номер телефона родителей",
        },
        incorrect_phone: {
          value: false,
          message: "Неправильный формат номера телефона",
        },
        incorrect_parents_phone: {
          value: false,
          message: "Неправильный формат номера телефона",
        },
        parent_name: {
          value: false,
          message: "Введите ФИО родителя",
        },
      },
      currentErrorMessage: "",
    };
  },
  computed: {
    ...mapState(["userData", "areasList", "userAwards"]),
  },
  methods: {
    ...mapActions([
      "updateUserProfile",
      "getAreas",
      "getUserAwards",
      "getAwardTypes",
      "addAward",
      "editAward",
      "deleteAward",
      "getAwardPlaces",
      "getAwardCompetition",
    ]),
    onDeleteAward(award) {
      this.deleteAward(award).then((res) => {
        if (res.status === 204) {
          this.userAwardsData = this.userAwardsData.filter(
            (el) => el.id !== award.id
          );
        } else {
          alert(res.status);
        }
      });
    },
    onAddFile(data, type) {
      data = Object.assign({}, data);
      data.attachments = data.attachments.map((el) => el.id);
      if (type === "edit") {
        return this.editAward(data).then((res) => {
          this.userAwardsData = this.userAwardsData.map((el) => {
            if (el.id === res.data.id) {
              el = res.data;
            }
            return el;
          });
          this.$emit("onCloseModal");
        });
      }
      this.addAward(data).then((res) => {
        this.userAwardsData.push(res.data);
        this.$emit("onCloseModal");
      });
    },
    openModal(mode, data) {
      data.awardTypesData = this.awardTypesData;
      data.awardPlaces = this.awardPlaces;
      data.onAdd = this.onAddFile;
      data.competitions = this.awardCompetition;
      this.$emit("onOpenModal", mode, data);
    },
    onBuildUserData(data) {
      this.userProfileData = JSON.parse(JSON.stringify(data));
      if (this.userProfileData.area && this.userProfileData.area.id) {
        this.userProfileData.area = this.userProfileData.area.id;
      }
      if (!this.userProfileData.is_accompanying) {
        this.userAwardsData = this.userAwards;
      }
      this.getAwardTypes().then((res) => {
        this.awardTypesData = res;
        this.awardTypesData.forEach((item) => {
          this.getAwardCompetition(item.id).then((res) => {
            this.awardCompetition[item.id] = res;
          });
        });
      });
      this.getAwardPlaces().then((res) => {
        this.awardPlaces = res;
      });
    },
    changeValue(data) {
      const type = data[1];
      let value = data[0];
      this.userProfileData[type] = value;
    },
    changeAttachments(data) {
      this.userProfileData[data.fieldname] = data.value;
      this.requireErrors[data.fieldname] = false;
    },

    changePortfolioValue(data) {
      console.log("data", data);
    },
    resetError(model) {
      switch (model) {
        case "phone":
          this.fieldsErrors.empty_phone.value = false;
          this.fieldsErrors.incorrect_phone.value = false;
          break;
        case "parents_phone": {
          this.fieldsErrors.empty_parents_phone.value = false;
          this.fieldsErrors.incorrect_parents_phone.value = false;
          break;
        }
        default:
          this.fieldsErrors[model].value = false;
      }
      this.currentErrorMessage = "";
    },

    isNull(value) {
      return value === null;
    },
    validation() {
      let errors = [];
      let fieldsForLengthValidation = [
        "last_name",
        "first_name",
        "fathers_name",
        "place_of_birth",
        "school_address",
        "school_name",
      ];
      if (!this.userProfileData.is_accompanying) {
        fieldsForLengthValidation.push("parent_name");
      }
      fieldsForLengthValidation.forEach((item) => {
        if (this.userProfileData[item].length === 0) {
          errors.push(item);
        }
      });
      if (this.isNull(this.userProfileData.date_of_birth)) {
        errors.push("date_of_birth");
      }

      if (this.userProfileData.phone.replace(/\D/g, "").length === 0) {
        errors.push("empty_phone");
      }
      if (
        this.userProfileData.phone.replace(/\D/g, "").length > 0 &&
        this.userProfileData.phone.replace(/\D/g, "").length < 11
      ) {
        errors.push("incorrect_phone");
      }

      if (!this.userProfileData.is_accompanying) {
        if (
          this.userProfileData.parents_phone.replace(/\D/g, "").length === 0
        ) {
          errors.push("empty_parents_phone");
        }

        if (
          this.userProfileData.parents_phone.replace(/\D/g, "").length > 0 &&
          this.userProfileData.parents_phone.replace(/\D/g, "").length < 11
        ) {
          errors.push("incorrect_parents_phone");
        }
      }

      if (errors.length > 0) {
        errors.forEach((item) => {
          this.fieldsErrors[item].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },

    onSaveProfile() {
      const userProfileData = JSON.parse(JSON.stringify(this.userProfileData));

      if (!this.validation()) {
        return false;
      }

      this.pending = true;

      userProfileData.phone = userProfileData.phone.replace(/\D/g, "");

      if (!this.userProfileData.is_accompanying) {
        userProfileData.parents_phone = userProfileData.parents_phone.replace(
          /\D/g,
          ""
        );
      } else {
        userProfileData.parents_phone = "";
        this.userProfileData.parents_phone = "";
      }

      this.updateUserProfile(userProfileData).then((response) => {
        this.pending = false;
        if (response.status === 200) {
          this.$emit("onOpenModal", "notification", {
            text: "Личный кабинет обновился",
            alignCenter: true,
          });
        } else {
          this.$emit("onOpenModal", "notification", {
            text: `Статус ошибки -> ${response.status}`,
          });
        }
      });
    },
  },
  mounted() {
    this.onBuildUserData(this.userData);
    this.getAreas();
    if (this.$route.query.section === "portfolio") {
      document.getElementById("portfolio").scrollIntoView();
    }
  },
  watch: {
    areasList(val) {
      if (!this.userProfileData.area) {
        this.userProfileData.area = val[0].id;
      }
    },
  },
};
</script>
